/*
 * @Author: yuanweijiang
 * @Date: 2024-08-29 11:31:11
 * @LastEditors: yuanweijiang
 */
/*
 * @Description: 图层管理
 */
import request from '@/network/request'
/**
 *
 */
export function getList(param) {
    return request.send('/business/skyline/list', 'get', param)
}
export function saveData(data) {
    return request.send('/business/skyline/save', 'post', data, { headers: { 'Content-Type': 'multipart/form-data' } })
}
export function delData(id) {
    return request.send('/business/skyline/delete/' + id, 'post')
}
export function saveList(data) {
    return request.send('/business/home/saveOrUpdateToolData', 'post', data)
}
export function toolList(param) {
    return request.send('/business/home/toolDataList', 'get', param)
}

export function deltoolList(id) {
    return request.send('/business/home/removeTool/' + id, 'post')
}
export function gettoolList(id) {
    return request.send('/business/home/toolList', 'get')
}
export function getUserTool(data) {
    return request.send('/business/home/recordUserTool', 'post', data)
}
